/**
 * 配置编译环境
 */
const env = process.env.NODE_ENV || 'dev'
export default env
